import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-gear',
    templateUrl: './gear.component.svg',
    styleUrls: ['./gear.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GearComponent {}
